module.exports = __webpack_public_path__ + "static/media/donation_box_icon.70a1d5f8.svg";